export function appendScript(url, callback) {
  const head = document.getElementsByTagName('head')[0];
  const theScript = document.createElement('script');
  theScript.type = 'text/javascript';
  theScript.src = url;
  theScript.onreadystatechange = callback;
  theScript.onload = callback;
  head.appendChild(theScript);
}

export function readImage(url) {
  return new Promise((resolve, reject) => {
    let img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject();
    img.src = url;
  });
}

export function numberWithDelimiter(number) {
  const [integerPart, decimalPart] = number.toString().split(".");
  const delimited = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return decimalPart === undefined ? delimited : `${delimited}.${decimalPart}`;
}

export function krw(price) {
  if (price === 0) {
    return "무료";
  }

  return `${numberWithDelimiter(price)}원`;
}

export default {};